export type TCountryValidation = {
  pattern: RegExp;
  maxLength: number;
};

export type TValidationByCountryCode = {
  [key: string]: TCountryValidation;
};

export default {
  NL: {
    pattern: /^[0-9]{8}$/,
    maxLength: 8,
  },
  BE: {
    pattern: /^[0-9]{10}$/,
    maxLength: 10,
  },
} as TValidationByCountryCode;
